<!-- .block-slideshow -->
<div *ngIf="slides.length" class="block-slideshow block block-slideshow--layout--full"
style="margin-top: -40px;">
    <div class="block-slideshow__body">
        <div class="owl-carousel owl-theme">
            <div class="item" *ngFor="let slide of slides">
                <img *ngIf="width() > 800" class="slide-desktop" [src]="slide.image_full" >
                <img *ngIf="width() <= 800" class="slide-mobile" [src]="slide.image_mobile">
            </div>
        </div>
        <!-- <owl-carousel-o *ngIf="slides?.length" [options]="options" appOwlPreventClick>
            <ng-template *ngFor="let slide of slides" carouselSlide>
                <a class="block-slideshow__slide" href="" appClick>
                    <div class="block-slideshow__slide-image block-slideshow__slide-image--desktop" [ngStyle]="{'background-image': 'url('+(withDepartments ? slide.image_classic : slide.image_full)+')'}"></div>
                    <div style="background-size: contain" class="block-slideshow__slide-image block-slideshow__slide-image--mobile" [ngStyle]="{'background-image': 'url('+slide.image_mobile+')'}"></div>
                    <div class="block-slideshow__slide-content">
                        <div class="block-slideshow__slide-title" [ngStyle]="{'color': slide.textColor ? slide.textColor : 'unset'}" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slide.title)"></div>
                        <div class="block-slideshow__slide-text" [ngStyle]="{'color': slide.textColor ? slide.textColor : 'unset'}" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slide.text)"></div>
                        <div class="block-slideshow__slide-button">
                            <span class="btn btn-primary btn-lg">Acquista Ora</span>
                        </div>
                    </div>
                </a>
            </ng-template>
        </owl-carousel-o> -->
    </div>
</div>
<!-- .block-slideshow / end -->